export default __webpack_public_path__ + "static/media/CustomAddIcon.897500f1.png";